import React, { useState, useCallback, useEffect, useRef } from "react";
import Loading from "../../components/layout/Loading";
import ExamContent from "../../components/exam/ExamContent";
import { useManageExam } from "../../hooks/useManageExam";
import { useTimeChangeDetector } from "../../hooks/useTimeChangeDetector";
import PracticeExamFinished from "../../components/errors/PracticeExamFinished";
import { useExamTabLock, TAB_LOCK_STATUS } from "../../hooks/useExamTabLock";
import ExamTabConflictDialog from "../../components/common/ExamTabConflictDialog";
import { useExam } from "../../context/ExamContext";

const Exam = () => {
  // useTimeChangeDetector(() => {
  //   alert("System time has been modified. The exam will now reload.");
  //   window.location.reload();
  // });

  const [showExam, setShowExam] = useState(false);
  const { uprId } = useExam();
  const hasFinishedRef = useRef(false);

  const {
    activeView,
    timeLeft,
    isDemoExam,
    isLoadingOngoingExam,
    loadingListeningAudio,
    errorOngoingExam,
    sessionDetails,
    isLoadingSessionDetails,
    finishSession,
    resetInitialization, // Bug Fix #3: For re-init after takeover
  } = useManageExam();

  // Get productSessionId from sessionDetails
  const productSessionId = sessionDetails?._id;


  // Tab lock for real exams (not demo)
  const enableTabLock = !isDemoExam && productSessionId;
  const {
    status: tabLockStatus,
    conflict,
    kickedMessage,
    takeover,
    leave: leaveTabLock,
    isConnected,
  } = useExamTabLock(productSessionId, uprId, enableTabLock, resetInitialization);

  // Tab lock is still initializing (connecting to WebSocket)
  // We need to wait until we know if there's a conflict or not
  const isTabLockInitializing = enableTabLock && tabLockStatus === TAB_LOCK_STATUS.CONNECTING;

  // Cleanup when exam finishes
  useEffect(() => {
    if (activeView === "examFinish" && !hasFinishedRef.current) {
      hasFinishedRef.current = true;
      // Release tab lock
      if (leaveTabLock) {
        leaveTabLock();
      }
      // Finish product session
      if (finishSession) {
        finishSession();
      }
    }
  }, [activeView, leaveTabLock, finishSession]);

  // Handle cancel from conflict dialog
  const handleCancel = useCallback(() => {
    // Redirect to main app or close tab
    window.close();
    // Fallback if window.close() doesn't work
    window.location.href = process.env.REACT_APP_MAIN_APP_URL || "/";
  }, []);

  // if ((!isDemoExam && isLoadingOngoingExam)) return <Loading />;
  // console.log(isDemoExam);
  // console.log(isLoadingOngoingExam);
  // console.log(isLoadingSessionDetails);
  // console.log(loadingListeningAudio);

  // Show loading screen while:
  // 1. Session details or ongoing exam data is loading
  // 2. Listening audio is being downloaded
  // 3. Tab lock is connecting (waiting to know if there's a conflict)
  if (
    (!isDemoExam && (isLoadingOngoingExam || isLoadingSessionDetails)) ||
    loadingListeningAudio
    // ||    isTabLockInitializing
  ) {
    return <Loading />;
  }

  if (errorOngoingExam) return <div>{errorOngoingExam}</div>;

  // console.log(sessionDetails);

  //Through heartbeat we check if user is not connected then we make that session completed and when user try to ope nthat page with link he wil se that page
  // if (sessionDetails?.isCompleted) {
  //   return <PracticeExamFinished />;
  // }

  // Show tab lock dialogs for conflicts/kicked status
  const showTabLockDialog =
    enableTabLock &&
    (tabLockStatus === TAB_LOCK_STATUS.CONFLICT ||
      tabLockStatus === TAB_LOCK_STATUS.KICKED ||
      tabLockStatus === TAB_LOCK_STATUS.DISCONNECTED);

  return (
    <>
      {/* Tab lock conflict/kicked dialog */}
      {showTabLockDialog && (
        <ExamTabConflictDialog
          status={tabLockStatus}
          conflict={conflict}
          kickedMessage={kickedMessage}
          onTakeover={takeover}
          onCancel={handleCancel}
        />
      )}

      <ExamContent
        activeView={activeView}
        showExam={showExam}
        timeLeft={timeLeft}
        setShowExam={setShowExam}
        isDemoExam={isDemoExam}
      />
    </>
  );
};

export default Exam;
